/**
 * Плитка типу файлу (UIUX/field-types/file; прототип filesList): розширення великими (до 4 знаків) і тон — PDF помаранчевий,
 * документи синій, таблиці зелений, зображення фіолетовий, решта сірий; previewable — зображення або PDF (попередній перегляд).
 */
export function fileTile(fileName: string, mimeType: string): { ext: string; tone: string; previewable: boolean } {
  const dot = fileName.lastIndexOf('.');
  const ext = (dot > 0 ? fileName.slice(dot + 1) : '').toUpperCase().slice(0, 4) || 'FILE';
  const kind = `${ext} ${mimeType}`.toLowerCase();
  const image = mimeType.startsWith('image/') || /\b(png|jpe?g|gif|webp|svg)\b/.test(kind);
  const pdf = kind.includes('pdf');
  const tone = pdf ? 'var(--solid-orange)'
    : /\b(doc|docx|odt|rtf)\b|word/.test(kind) ? 'var(--solid-blue)'
      : /\b(xls|xlsx|ods|csv)\b|sheet|excel/.test(kind) ? 'var(--solid-green)'
        : image ? 'var(--solid-purple)' : 'var(--solid-grey)';
  return { ext, tone, previewable: image || pdf };
}
